import { type Observable, interval, merge, retry, switchMap, map } from 'rxjs'
import { type WorkspaceMember } from './WorkspaceMember'

/**
 * Calls `updateLastSeen` and `updateLastLogin` when appropriate.
 *
 * @param currentMember$
 * @param updateLastLogin
 * @param updateLastSeen
 * @param updateLastSeenInterval
 */
export function lastSeenSync(
  currentMember$: Observable<WorkspaceMember>,
  updateLastLogin: (member: WorkspaceMember) => Promise<unknown>,
  updateLastSeen: (member: WorkspaceMember) => Promise<unknown>,
  /* istanbul ignore next */
  updateLastSeenInterval = 120000,
) {
  return merge(
    currentMember$.pipe(
      switchMap((m) => updateLastLogin(m)),
      retry({ resetOnSuccess: true, delay: 5_000, count: 10 }),
    ),
    currentMember$.pipe(
      // Whenever a workspace gets selected, start a timer (and stop the previous one).
      // When the timer elapses, emit the current member and trigger the sync.
      switchMap((member) =>
        interval(updateLastSeenInterval).pipe(map(() => member)),
      ),
      switchMap((m) => updateLastSeen(m)),
      retry({ resetOnSuccess: true, delay: 5_000, count: 10 }),
    ),
  )
}
